/* eslint-env amd */
define(['actual/underscore'], function (_) {
    return _;
});
